import { NursingQuestion, NursingQuestionAnswerType } from "./nursing-question-settings.consts";

export interface NursingQuestionFilters {
  searchTerm: string;
  answerTypes: NursingQuestionAnswerType[];
  isVBP: boolean | null;
  isVital: boolean | null;
  showOnPatient: boolean | null;
  showOnAgency: boolean | null;
}

export function filterNursingQuestions(
  questions: NursingQuestion[],
  filters: NursingQuestionFilters
): NursingQuestion[] {
  const term = filters.searchTerm.trim().toLowerCase();

  return questions.filter((question) => {
    if (
      term !== "" &&
      !question.questionText.toLowerCase().includes(term) &&
      !(question.possibleAnswers ?? []).some((answer) => answer.text.toLowerCase().includes(term))
    ) {
      return false;
    }
    if (filters.answerTypes.length > 0 && !filters.answerTypes.includes(question.answerType)) {
      return false;
    }
    if (filters.isVBP !== null && question.isVBP !== filters.isVBP) {
      return false;
    }
    if (filters.isVital !== null && question.isVital !== filters.isVital) {
      return false;
    }
    if (filters.showOnPatient !== null && question.showOnPatient !== filters.showOnPatient) {
      return false;
    }
    if (filters.showOnAgency !== null && question.showOnAgency !== filters.showOnAgency) {
      return false;
    }
    return true;
  });
}

export function emitRefreshPatientQuestionTypes() {
  window.dispatchEvent(
    new CustomEvent("from-webapp-react", {
      detail: { type: "refreshPatientQuestionTypes" },
    })
  );
}
